import { render, staticRenderFns } from "./AdminVideosBank.vue?vue&type=template&id=749a4199&scoped=true"
import script from "./AdminVideosBank.vue?vue&type=script&lang=js"
export * from "./AdminVideosBank.vue?vue&type=script&lang=js"
import style0 from "./AdminVideosBank.vue?vue&type=style&index=0&id=749a4199&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749a4199",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('749a4199')) {
      api.createRecord('749a4199', component.options)
    } else {
      api.reload('749a4199', component.options)
    }
    module.hot.accept("./AdminVideosBank.vue?vue&type=template&id=749a4199&scoped=true", function () {
      api.rerender('749a4199', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminVideosBank.vue"
export default component.exports